/* CraftPK cart drawer, upsells and bundles */
(function () {
  var SAVE = 50000;
  function money(paisa) {
    var r = Math.round(paisa / 100);
    return 'Rs ' + r.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function drawer() { return document.getElementById('cart-drawer'); }
  function update(cart) {
    document.querySelectorAll('[data-cp-ship]').forEach(function (box) {
      var host = box.closest('[data-cp-threshold]') || document.querySelector('[data-cp-threshold]');
      var limit = parseInt(host ? host.getAttribute('data-cp-threshold') : 300000, 10);
      var total = cart ? cart.total_price : 0;
      var count = cart ? cart.item_count : 0;
      var msg = box.querySelector('[data-cp-ship-msg]');
      var bar = box.querySelector('[data-cp-ship-bar]');
      if (!count) { box.hidden = true; return; }
      box.hidden = false;
      var pct = Math.min(100, Math.round(total / limit * 100));
      if (bar) bar.style.width = pct + '%';
      box.classList.toggle('is-done', total >= limit);
      if (msg) msg.innerHTML = total >= limit
        ? '<b>You have unlocked free delivery</b>'
        : 'Add <b>' + money(limit - total) + '</b> more for <b>free delivery</b>';
    });
    upsell(cart);
    discounts(cart);
    var d = drawer();
    if (d) d.classList.toggle('is-empty', !cart || !cart.item_count);
    setTimeout(tidy, 60);
  }
  function discounts(cart) {
    var box = document.querySelector('[data-cp-disc]');
    var label = document.querySelector('[data-cp-sub-label]');
    if (!box) return;
    var saved = cart ? (cart.original_total_price || 0) - (cart.total_price || 0) : 0;
    if (!cart || !cart.item_count || saved <= 0) {
      box.hidden = true; box.innerHTML = '';
      if (label) label.textContent = label.getAttribute('data-default') || label.textContent;
      return;
    }
    if (label && !label.getAttribute('data-default')) label.setAttribute('data-default', label.textContent);
    var map = {}, order = [];
    function add(t, amt) { t = t || 'Discount'; if (!(t in map)) { map[t] = 0; order.push(t); } map[t] += amt || 0; }
    (cart.items || []).forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (a) { add(a.discount_application && a.discount_application.title, a.amount); });
    });
    (cart.cart_level_discount_applications || []).forEach(function (a) { add(a.title, a.total_allocated_amount); });
    if (!order.length) add('Discount', saved);
    var esc = function (t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; };
    var html = '<div><span>Subtotal</span><span>' + money(cart.original_total_price) + '</span></div>';
    order.forEach(function (t) { html += '<div class="is-disc"><span>' + esc(t) + '</span><span>-' + money(map[t]) + '</span></div>'; });
    box.innerHTML = html; box.hidden = false;
    if (label) label.textContent = 'Total';
  }
  function upsell(cart) {
    var box = document.querySelector('[data-cp-upsell]');
    if (!box) return;
    var count = cart ? cart.item_count : 0;
    if (!count) { box.hidden = true; return; }
    var inCart = (cart.items || []).map(function (i) { return String(i.variant_id); });
    var shown = 0;
    box.querySelectorAll('[data-cp-upsell-item]').forEach(function (it) {
      var show = inCart.indexOf(it.getAttribute('data-variant')) === -1 && shown < 3;
      it.hidden = !show; if (show) shown++;
    });
    var ttl = box.querySelector('[data-cp-upsell-ttl]');
    if (ttl) ttl.innerHTML = count >= 2
      ? '<span class="cp-upsell__ok">Bundle unlocked: ' + money(SAVE) + ' off at checkout</span>You may also like'
      : 'Add one more watch &amp; <b>save ' + money(SAVE) + '</b>';
    box.hidden = shown === 0;
  }
  function tidy() {
    document.querySelectorAll('.cp-line__variant').forEach(function (v) { v.classList.toggle('is-default', v.textContent.trim() === 'Default Title'); });
  }
  function refresh() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { update(c); return c; }).catch(function () {});
  }
  function addItems(ids, btn) {
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = 'Adding…'; }
    var items = ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (window.CartJS && typeof window.CartJS.getCart === 'function') { window.CartJS.getCart(); }
        return refresh();
      })
      .then(function () {
        var d = drawer(); if (d) d.classList.add('active');
        if (btn) { btn.textContent = 'Added'; setTimeout(function () { btn.innerHTML = label; btn.disabled = false; btn.classList.remove('is-loading'); }, 1400); }
      })
      .catch(function (err) {
        if (btn) { btn.textContent = (err && err.description) ? 'Not available' : 'Try again'; setTimeout(function () { btn.innerHTML = label; btn.disabled = false; btn.classList.remove('is-loading'); }, 2000); }
      });
  }
  function bundleCalc(root) {
    var boxes = root.querySelectorAll('[data-cp-bundle-item]');
    var save = parseInt(root.getAttribute('data-save') || SAVE, 10);
    var sum = 0, was = 0, n = 0;
    boxes.forEach(function (b) {
      b.closest('.cp-pbundle__item').classList.toggle('is-off', !b.checked);
      if (b.checked) { n++; sum += parseInt(b.getAttribute('data-price'), 10); was += parseInt(b.getAttribute('data-compare'), 10); }
    });
    var final = n >= 2 ? sum - save : sum;
    var q = function (s) { return root.querySelector(s); };
    if (q('[data-cp-bundle-count]')) q('[data-cp-bundle-count]').textContent = n;
    if (q('[data-cp-bundle-total]')) q('[data-cp-bundle-total]').textContent = money(final);
    if (q('[data-cp-bundle-was]')) q('[data-cp-bundle-was]').textContent = was > final ? money(was) : '';
    if (q('[data-cp-bundle-saverow]')) q('[data-cp-bundle-saverow]').hidden = n < 2;
    if (q('[data-cp-bundle-add]')) q('[data-cp-bundle-add]').textContent = n >= 2 ? 'Add ' + n + ' items to cart' : 'Add to cart';
  }
  function boot() {
    refresh();
    if (window.jQuery) {
      window.jQuery(document).on('cart.requestComplete', function () { refresh(); });
    }
    document.querySelectorAll('[data-cp-bundle]').forEach(bundleCalc);
    document.addEventListener('change', function (e) {
      var root = e.target.closest && e.target.closest('[data-cp-bundle]');
      if (root && e.target.matches('[data-cp-bundle-item]')) bundleCalc(root);
    });
    document.addEventListener('click', function (e) {
      var t = e.target;
      var add = t.closest && t.closest('[data-cp-add-items]');
      if (add) { e.preventDefault(); e.stopPropagation(); addItems(add.getAttribute('data-cp-add-items').split(','), add); return; }
      var b = t.closest && t.closest('[data-cp-bundle-add]');
      if (b) {
        e.preventDefault();
        var root = b.closest('[data-cp-bundle]');
        var ids = [];
        root.querySelectorAll('[data-cp-bundle-item]').forEach(function (c) { if (c.checked) ids.push(c.value); });
        if (ids.length) addItems(ids, b);
      }
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { var d = drawer(); if (d) d.classList.remove('active'); }
    });
    var obs = drawer();
    if (obs && 'MutationObserver' in window) {
      new MutationObserver(tidy).observe(obs, { childList: true, subtree: true });
      new MutationObserver(function () {
        document.documentElement.classList.toggle('cp-cart-open', obs.classList.contains('active'));
      }).observe(obs, { attributes: true, attributeFilter: ['class'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
